module.exports = __webpack_public_path__ + "img/wire-3.c2e2c16a.jpg";